import axios from 'axios';
import { handleLogoutCookie } from './app/utils/cookies';
import { createBrowserHistory } from 'history';
import { setCookieMessage } from './app/utils/cookiesLink';

import { saveCustomerInfo } from './store/actions/AuthAction';
import { store } from './store/store';

const history = createBrowserHistory();

const instance = axios.create({
    baseURL: process.env.REACT_APP_URL_API_AUTHENTICATION,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
    },
    timeout: process.env.REACT_APP_TIMEOUT_API,
});

// Thêm trường domain và link vào mỗi yêu cầu gửi đi
instance.interceptors.request.use((config) => {
    const currentURL = window.location.href;
    const url = new URL(currentURL);
    const domain = url.origin;
    const link = url.pathname;

    if (config.method === 'get') {
        config.params = {
            ...config.params,
            domain: domain,
            link: link,
        };
    } else {
        config.data = {
            ...config.data,
            domain: domain,
            link: link,
        };
    }

    return config;
});

instance.interceptors.response.use(
    (response) => {
        if (response.data.status === 401) {
            setCookieMessage(response.data.message || 'Tài khoản không có quyền truy cập!');

            window.location.href = process.env.REACT_APP_LINK_WEB_LOGIN + '/home'; // đi về trang mặc định

            // handleLogoutCookie();
            // history.push('/');
            // store.dispatch(saveCustomerInfo({ token: '', fullName: '' }));
        }
        return response.data;
    },
    (error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
            setCookieMessage(error.response.data.message || 'Tài khoản không có quyền truy cập!');

            window.location.href = process.env.REACT_APP_LINK_WEB_LOGIN + '/home'; // đi về trang mặc định

            // handleLogoutCookie();
            // history.push('/');
            // store.dispatch(saveCustomerInfo({ token: '', fullName: '' }));
        }
        return error.response.data;
    }
);

// instance.defaults.headers.common['Authorization'] = "";

export default instance;
